"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPicture = exports.ContainerWithVariableAspectRatio = exports.ContainerWithConstantAspectRatio = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ElementResizeListener = _interopRequireDefault(require("../ElementResizeListener"));
var _Picture = _interopRequireDefault(require("../Picture"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var ContainerWithConstantAspectRatio = exports.ContainerWithConstantAspectRatio = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContainerWithConstantAspectRatio",
  componentId: "sc-kzyt1s-0"
})(["position:relative;width:100%;"]);
var ContainerWithVariableAspectRatio = exports.ContainerWithVariableAspectRatio = (0, _styledComponents["default"])(ContainerWithConstantAspectRatio.withComponent(_ElementResizeListener["default"])).withConfig({
  displayName: "styles__ContainerWithVariableAspectRatio",
  componentId: "sc-kzyt1s-1"
})(["height:100%;"]);
var StyledPicture = exports.StyledPicture = (0, _styledComponents["default"])(_Picture["default"]).withConfig({
  displayName: "styles__StyledPicture",
  componentId: "sc-kzyt1s-2"
})(["height:100%;width:100%;", ""], function (p) {
  return p.shouldBeAbsolutelyPositioned && "\n    left: 0;\n    position: absolute;\n    top: 0;\n  ";
});
//# sourceMappingURL=styles.js.map